export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-02.jpg'),
        title: 'ビジネスプロセス',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'すべての健全に運営される企業の中核',
      description: `<p style="font-size:1.05rem">
      ビジネスプロセスは組織の目標達成の基盤です。流れるようで効率的、そして高度に整理されたプロセスは目標を実現するための重要な要素です。全ての業務活動は健全な運営に不可欠であり、あらゆる企業は共通の設計図—ビジネスプロセス—に基づいています。この観点から、整備され簡略化されたビジネスプロセスは企業の骨格となります。私たちは幅広い経験を有し、現状の業務プロセスを分析してワークフローを最適化し、非効率を排除して各工程を改善します。プロセスの簡素化は私たちの重要な目標であり、ビジネスプランニングの一部です。MaesInfoは、お客様の業務効率向上と運用コスト削減を支援する経験と能力を備えています。</p>`
    },
    {
      title: 'MaesInfoが御社にもたらす持続的な利益：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-02.jpg')+`)"></span>
      <span>御社の業務プロセスとシステム実装を調査・分析し、プロセスや運用の最適化改善案を提案します。ボトルネックの特定と排除、資源の非効率的使用の是正、不要な手順の削減、手戻り（リワーク）を減らすことでコミュニケーションを改善します。詳細なレポートを作成し、改善が必要な領域を明確に示し、業務プロセス最適化の支援を行います。</span>`
    }
  ]
}
